import { calcSpacing } from 'src/components/foundations';
import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const CardBodyStyled = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  padding: ${calcSpacing(2)}px;
`;
